import React from 'react';
const css = `
    html {
        width: 255mm;
        padding: 0 20mm;
    }

    body {
        font-family: monospace, Lucida Console, Lucida Sans Typewriter, monaco, Bitstream Vera Sans Mono, Menlo-Regular;
        font-size: 32pt;
    }

    @font-face {
        font-family: 'Free 3 of 9';
        font-style: normal;
        font-weight: normal;
        src: url('data:font/truetype;charset=utf-8;base64,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') format('truetype');
    }

    table {
        width: 100%;
        border-width: 0;
        border-collapse: collapse;
        table-layout: fixed;
    }
    table.add-padding th,
    table.add-padding td {
        padding: 0.25cm 0cm;
    }

    table th, table td{
        vertical-align: top;
    }

    table.dates th {
        width: 50%
    }

    table td{
        word-wrap: break-word;
    }

    .logo-image-container {
        zoom: 3;
        margin: 0 auto;
        height: 1.55cm;
        margin-bottom: 0.25cm;
    }
    .logo-image-container.zoom-2 {
        zoom: 2;
    }

    .logo-image-div {
        text-align: center;
    }
    .logo-image-div img {
        margin: 0 auto;
    }

    .header-title {
        text-transform: uppercase;
    }

    .table-products {
        border-collapse: collapse;
    }

    table.table-products.payments {
        table-layout: initial;
    }

    .table-products td:empty {
        display: table-cell;
    }

    .separator {
        width: 100%;
        height: 0.35cm;
    }

    .separator-high {
        width: 100%;
        height: 1cm;
    }

    .text-center {
        text-align: center;
    }

    .text-left {
        text-align: left;
    }

    table.text-left th, table.text-left td{
        padding-right: 7px;
    }

    .text-right {
        text-align: right;
    }

    .blank_row
    {
        height: 50px;
    }
`
function FailedTransactioReceipt(props) {
    let today = new Date();
    let date = today.toLocaleDateString("en-US");
    let time = today.toLocaleTimeString("en-US");
    const logo = `data:image/png;base64,${props.receiptAttributes.logo}`
        return(
            <html>
                <head>
                    <style>
                        {css}
                    </style>
                </head>
                <body>
                    <div>
                        
                    <div className='logo-image-container zoom-2 logo-image-div'>
                        {props.receiptAttributes.logo && props.receiptAttributes.isPrintLogoKiosk &&  <img src={logo} alt = 'Store logo'/>}
                    </div>                    
                    <table className='text-center'>
                        <tbody>
                            <tr className='blank_row'><td></td></tr>
                            <tr><td><span className='header-title'>PAYMENT SUCCESSFUL</span></td></tr>
                            <tr className='blank_row'><td></td></tr>
                        </tbody>
                    </table>    
                        <div className='separator'></div>
                    <table className='text-left dates add-padding'>
                        <tbody>
                            <tr><td>Date:</td><td>{date}</td></tr>
                            <tr><td>Time:</td><td>{time}</td></tr>
                            <tr><td>Acc. Number</td><td>{`***${props.accountNumber.substr(-4)}`}</td></tr>
                            <tr><td>Store ID:</td><td>{props.storeId}</td></tr>
                            <tr className='blank_row'>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                        <div className='separator'></div>
                    <table className='table-products payments add-padding'>
                        <tbody>
                            <tr>
                                <td className='text-right' width='40%' style={{overflow: 'hidden', whiteSpace: 'nowrap'}}></td>
                                <td colSpan='2' className='text-right' style={{overflow: 'hidden',whiteSpace: 'nowrap', borderBottom: '1px dashed #555555'}}></td>
                            </tr>
                            <tr>
                                <td className='text-right'></td>
                                <td>Cash Total:</td>
                                <td className='text-right'>${props.cashInserted}</td>
                            </tr>
                        </tbody>
                    </table>
                        <div className='separator-high'></div>
                        <div className='text-center'>{props.warningDisclaimer}</div>
                        <div className='separator-high'></div>
                        <div className='separator-high'></div>
                        <div className='text-center'>Please keep this receipt for your <br /> records</div>
                        <div className='separator-high'></div>
                    </div>
                </body>
                </html>
        );
    }

export default FailedTransactioReceipt;
